import {RecordKind} from 'core/Record';
import {UpdatersRegistry} from '../types';
import {afterIncome} from './income';
import {afterRefill} from './refill';
import {afterSpend} from './spend';

export const budgetUpdaters: UpdatersRegistry = {
  [RecordKind.Refill]: afterRefill,
  [RecordKind.Income]: afterIncome,
  [RecordKind.Spend]: afterSpend,
};
